/**
 * Duplicates backend enum values: no type is shared between the two applications. They mirror
 * `AiTranscriptionDeliveryMode` (`apps/backend/src/enums/ai/ai-transcription-delivery-mode.enum.ts`),
 * the `AiModelFamily` values and the `REALTIME_SUPPORT` table. The server stays the authority and
 * rejects any other combination.
 */
export const REALTIME_DELIVERY_MODE = 'realtime';
export const FILE_DELIVERY_MODE = 'file';

/** The single source of the real-time rule: the model family each provider kind can serve in real time. */
const REALTIME_FAMILY_BY_PROVIDER_KIND: Readonly<Record<string, string>> = Object.freeze({
	mistral: 'voxtral',
	openai_compatible: 'voxtral',
	openai: 'openai_transcribe',
	azure_openai: 'openai_transcribe',
});

const REALTIME_FAMILIES: readonly string[] = Object.values(REALTIME_FAMILY_BY_PROVIDER_KIND);

/** Whether some provider can serve this family in real time (the provider kind is not known to the form data). */
export const isRealtimeFamily = (family: string | null): boolean => {
	return family !== null && REALTIME_FAMILIES.includes(family);
};

/** Whether this provider kind can serve this family in real time. */
export const canServeRealtime = (providerKind: string, family: string | null): boolean => {
	return family !== null && REALTIME_FAMILY_BY_PROVIDER_KIND[providerKind] === family;
};
